/* eslint-disable no-console */
export const trackError = (error: any) => {
  const message =
    typeof error === 'string'
      ? error
      : Object.prototype.hasOwnProperty.call(error, 'message')
        ? error.message
        : JSON.stringify(error)
  console.error(message)
}
